import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Drawer as DrawerType } from "melco-shared-logic";
import { FiltersDesignsList } from "./FiltersDesignsList";

export type AddDesignFilterDrawerProps = {
  designsFilterDrawer: DrawerType;
  designsFilter: any;
  setDesignsFilter: any;
};
export const AddDesignFilterDrawer: React.FC<AddDesignFilterDrawerProps> = ({
  designsFilterDrawer,
  designsFilter,
  setDesignsFilter,
}) => {
  const { t } = useTranslation();
  const { isDrawerOpen, closeDrawer } = designsFilterDrawer;
  return (
    <>
      <Drawer
        open={isDrawerOpen}
        onClose={closeDrawer}
        closable={true}
        placement="right"
        title={t("reporting.statistics.filters.design.add.title")}
        width={1000}
      >
        <FiltersDesignsList
          designsFilter={designsFilter}
          setDesignsFilter={setDesignsFilter}
        />
      </Drawer>
    </>
  );
};
